// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item[data-v-f47a6aa2]{flex-basis:150px;flex-grow:1;max-width:200px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
